import { TPopupInitialState, TPopupList } from '@@types/popup';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@stores/store';

const initialState: TPopupInitialState<TPopupList>[] = [];

export const popupSelector = (state: RootState) => state.popup;

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    resetPopup: (state, action) => {
      state = action.payload;
      return state;
    },
    openPopup: (state, action) => {
      const { type, props, Component, popupOptions, queryId, isBackClose } =
        action.payload;
      return state.concat({
        type,
        props,
        isOpen: true,
        Component,
        popupOptions,
        queryId,
        isBackClose,
      });
    },
    closePopup: (state, action) => {
      const _openPopups = [...state];
      _openPopups.pop();
      state = _openPopups;
      return state;
    },
    closePopupByQueryId: (state, action) => {
      const queryId = action.payload;
      const _openPopups = [...state];
      const _queryId = Array.isArray(queryId) ? queryId : [queryId];
      state = _openPopups.filter((popup) => !_queryId.includes(popup.queryId));
      return state;
    },
    openAlert: (state, action) => {
      const { alertOptions } = action.payload;
      const isExist = alertOptions?.id
        ? state.some((popup) => popup?.id === alertOptions.id)
        : false;

      if (!isExist)
        return state.concat({
          type: 'alert',
          alertOptions,
          isOpen: true,
          id: alertOptions?.id,
          isBackClose: alertOptions.isBackClose,
        });
      else {
        alertOptions.resolve(false);
        return state;
      }
    },
    closePopupById: (state, action) => {
      const id = action.payload;
      const _openPopups = [...state];
      const filtered = _openPopups.filter((popup) => popup?.id !== id);
      return filtered;
    },
    closeAllPopup: (state, action) => {
      state = [];
      return state;
    },
  },
});

export const {
  openPopup,
  closePopup,
  openAlert,
  closePopupByQueryId,
  closePopupById,
  resetPopup,
  closeAllPopup,
} = popupSlice.actions;

export default popupSlice.reducer;
